import React, { useState } from "react";
import { UploadCloud, Loader2, FileCheck2 } from "lucide-react";
import Navbar from "../components/Navbar";
import {API_URL,FAST_API_URL} from "../api"

export default function MedicineReminderUploader() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reminders, setReminders] = useState("");
  const [session, setsession] = useState({});

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("session", JSON.stringify(session));
    formData.append("phone_number", localStorage.getItem("patient_phone_number"));

    const response = await fetch(`${FAST_API_URL}/api/medicine_reminder_image`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    setReminders(data.analysis);
    setLoading(false);
    setsession(data.session_received);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-100 via-white to-white py-10 px-4">
  <Navbar />
  <div className="max-w-lg mx-auto mt-10 bg-white p-6 rounded-3xl shadow-xl border border-blue-100">
    <h2 className="text-2xl md:text-3xl font-bold text-center text-blue-700 mb-6">
      📄 Upload Your Prescription
    </h2>

    <label className="flex flex-col items-center justify-center w-full h-44 border-2 border-dashed border-blue-300 rounded-2xl cursor-pointer bg-blue-50 hover:bg-blue-100 transition-all duration-300">
      <UploadCloud className="w-10 h-10 text-blue-400 mb-2" />
      <p className="text-blue-600 font-medium text-sm">Click to upload or drag your file here</p>
      <input type="file" className="hidden" onChange={handleFileChange} />
    </label>

    {file && (
      <p className="mt-3 text-sm text-blue-700 text-center font-medium">
        📎 Selected: <span className="font-semibold">{file.name}</span>
      </p>
    )}

    <button
      onClick={handleUpload}
      disabled={!file || loading}
      className={`w-full mt-5 py-3 rounded-xl font-semibold text-white flex items-center justify-center transition-all duration-300 ${
        loading ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
      }`}
    >
      {loading ? (
        <>
          <Loader2 className="animate-spin w-5 h-5 mr-2" /> Analyzing...
        </>
      ) : (
        "Analyze Reminder"
      )}
    </button>

    {reminders && (
      <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-600 rounded-2xl shadow flex items-center gap-3">
        <FileCheck2 className="w-6 h-6 text-blue-700" />
        <span className="text-blue-800 text-sm font-medium">{reminders}</span>
      </div>
    )}
  </div>
</div>


  );
}
